(function() {
  'use strict';

  angular.module('quiz.quizIntro', [])
    .controller('QuizIntroCtrl', QuizIntroCtrl);

  QuizIntroCtrl.$inject = ['$scope'];

  function QuizIntroCtrl($scope) {
    $scope.state = {
      numberOfQuestions: 0,
      numberOfCompletedQuestions: 0
    };

    function setup() {
      if (!$scope.currentSlide || $scope.currentSlide.__type !== 'QuizFirstSlideInfo')
        return;

      var quizInfo = $scope.quizIdAmountOfQuestions[$scope.currentSlide.quizId];
      $scope.state.numberOfQuestions = quizInfo ? quizInfo.total : 0;
      $scope.state.numberOfCompletedQuestions = quizInfo ? quizInfo.completed : 0;
    }

    setup();
  }
})();